// extracted by mini-css-extract-plugin
export var headline = "highlighted-headline-module--headline--nZHF6";